enum ChatV2TemplateName {
	APPOINTMENT_SCHEDULING = 'canais_digitais_novo',
	CONTINUE_ATTENDANCE = 'continuar_atendimento_novo',
}

enum ChatV2Language {
	PORTUGUESE_BRAZIL = 'pt_BR',
}

enum ChatV2TransferReason {
	APPOINTMENT_SCHEDULING = 'AGENDAR_CONSULTAS',
	EXAMS_SCHEDULING = 'AGENDAR_EXAMES',
	BILLS = 'BOLETOS',
	SAC_HEALTH = 'SAC_SAUDE',
	SAC_ODONTO = 'SAC_ODONTO',
	WELL_BE_BORN = 'PROGRAMA_NASCER_BEM',
	ODONTO = 'ODONTO',
}

const CHAT_V2_DEBT_NEGOTIATION_URL =
	'https://www2.hapvida.com.br/modelo-5?vq=VQ_CHAT_NDISP_NEGOCIACAO';

export {ChatV2TemplateName, ChatV2Language, ChatV2TransferReason, CHAT_V2_DEBT_NEGOTIATION_URL};
